import Image from 'next/image';
import { useRouter } from 'next/router';
import { Box, Typography } from '@mui/material';

import { AppRoutes } from '@utils/appRoutes';
import Button from '@components/Button';

import useStyles from './useStyles';

interface IFaqComponent {
  slice: any;
}

const FaqComponent = ({ slice }: IFaqComponent) => {
  const { dish_image } = slice?.primary || {};
  const { url, alt } = dish_image || {};

  const router = useRouter();
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.leftContainer}>
        <Typography
          variant="h3"
          textAlign={{ xs: 'center', sm: 'left' }}
          color="cinnamon.main"
        >
          Do you have a question?
        </Typography>
        <Typography
          variant="body2"
          textAlign={{ xs: 'center', sm: 'left' }}
          color="garamMasala.main"
          maxWidth="610px"
        >
          Our FAQs answer most questions, but you can still ask us if you need
          any help.
        </Typography>
        <Button
          variant="contained"
          color="cinnamon"
          borderRadius="30"
          textColor="whitePepper.main"
          width="240px"
          onClick={() => router.push(AppRoutes.FAQS)}
        >
          Go to FAQs
        </Button>
      </Box>
      {url ? (
        <Box className={classes.imgWrapper}>
          <Image
            src={url}
            alt={alt || 'DISH IMAGE'}
            objectFit="contain"
            layout="fill"
          />
        </Box>
      ) : null}
    </Box>
  );
};

export default FaqComponent;
